import axios from './axios';

export default {
  list: () => axios.get('/perimetre_travauxes'),
};